import React from "react";
import { useGetAboutMe } from "pages/Profile/hooks/useGetAboutMe";
import { sanitizeTextForDisplay } from "shared/utils/dom/sanitizeExpandableTextAreaHtml";

const AboutMePrint = () => {
  const { aboutMe } = useGetAboutMe();

  if (!aboutMe?.currentAppearance) return null;

  return (
    <p
      className="mb-2.5"
      dangerouslySetInnerHTML={{
        __html: sanitizeTextForDisplay(aboutMe.currentAppearance),
      }}
    />
  );
};

export default AboutMePrint;
